import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type AlbumDb = {
  name: string;
}
const initial: AlbumDb = {
  name: ''
};

export type AlbumDbHashType = {
  [key in string]: AlbumDb;
}

export type AlbumAddPayload = {
  id?: string;
} & AlbumDb;
export type AlbumUpdatePayload = {
  id: string;
} & { [P in keyof AlbumDb]?: AlbumDb[P] };

export type AlbumDbState = {
  albums: AlbumDbHashType;
}

export const generateAlbumId = (): string => generateId('ia');
let initialState: AlbumDbState = { albums: {} };
const key = 'albums';

const albumDbSlice = createSlice({
  name: 'albumDb',
  initialState,
  reducers: {
    initializeAlbums(state: AlbumDbState) {
      state.albums = {};
    },
    addAlbum(state: AlbumDbState, action: PayloadAction<AlbumAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateAlbumId();
      state.albums[id] = obj;
      saveData(key, id, obj);
    },
    updateAlbum(state: AlbumDbState, action: PayloadAction<AlbumUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.albums[id] === undefined) {
        console.log(`*** Album not found: ${id}`);
      } else {
        const newData = { ...state.albums[id], ...obj };
        state.albums[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteAlbum(state: AlbumDbState, action: PayloadAction<AlbumUpdatePayload>) {
      const id = action.payload.id;
      delete state.albums[id];
      deleteData(key, id);
    },
    saveAlbums(state: AlbumDbState) {
      saveAllData(key, state.albums);
    },
    signUpAlbums(state: AlbumDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.albums, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: AlbumDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.albums = updatedValues;
      if (changed) saveAllData(key, state.albums);
    })
  }
})

export const { initializeAlbums, addAlbum, updateAlbum, deleteAlbum, saveAlbums, signUpAlbums } = albumDbSlice.actions;
export default albumDbSlice.reducer;
